<a href="https://twitter.com/share" [attr.data-text]="text" [attr.data-url]="url" data-size="large"
    class="twitter-share-button"></a>